let CourseGroup = Backbone.Model.extend(
    {
        defaults:
            {
                name: null,
            },
        getName: function () {
            return this.get('name')
        },


    });

let CourseGroupList = Backbone.Collection.extend(
    {
        model: CourseGroup,
        comparator: function (item) {
            return item.getName();
        }

    }
);
